import { useEffect, useState } from 'react';
import { useRouteHook } from '@shared/hooks';
import { RoutePaths } from '@shared/utils';
import { BaseInput, Button, ColorsEnum, ErrorMessage, Footer, Spinner, Text } from '@shared/widgets';
import { AuthApi } from '@shared/api/rest';

export const SignUpVcfcPage = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>('');
  const [companyCode, setCompanyCode] = useState<string>('');
  const [password, setPassword] = useState<string>('');

  const { navigate } = useRouteHook();

  useEffect(() => {
    document.title = 'Sign Up...';
  }, []);

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      await AuthApi.signup({ companyCode: companyCode, password: password });
      navigate(RoutePaths.success.onNavigate());
    } catch (error) {
      setError((error as Error).message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {isLoading && <Spinner position />}
      <div
        className='grow flex items-center justify-center bg-top bg-cover bg-no-repeat relative'
        style={{ backgroundImage: 'url(auth-bg-vcfc.jpg)' }}
      >
        <div className='bg-signal-black absolute top-0 left-0 right-0 bottom-0 z-10' />
        <div className='w-[171.5px] h-[323px] absolute top-2/4 left-0 -translate-y-2/4 z-20' style={{ backgroundImage: 'url(/half-vcfc.png)' }} />
        <div className='w-[536px] min-h-[500px] py-14 px-24 rounded-xl bg-[#0000006E] relative z-20'>
          <Text className='mb-[70px] text-center font-[Prata]' size='5xl' color={ColorsEnum.White}>
            Registration
          </Text>
          <form className='w-[270px] mx-auto' onSubmit={onSubmit}>
            <BaseInput className='mb-1' placeholder='Company Code' value={companyCode} onChange={setCompanyCode} />
            <Text className='mb-6' weight='light' size='xs' color={ColorsEnum.White}>
              Company code was sent to your company’s e-mail after signing the agreement
            </Text>
            <BaseInput className='mb-6' type='password' placeholder='Password' value={password} onChange={setPassword} />
            {error && (
              <div className='mb-6 py-2 px-3 rounded-sm flex items-center justify-center border border-red'>
                <ErrorMessage text={error} />
              </div>
            )}
            <Button className='mb-6' fullWidth color='primary' type='submit' disabled={!companyCode || !password || isLoading}>
              Register
            </Button>
            <Text className='text-center' weight='light' size='xs' color={ColorsEnum.White}>
              If you have questions, we are always glad to help <br />
              Contact us <span className='font-normal'>+420 567 567</span>
            </Text>
          </form>
        </div>
      </div>
      <Footer />
    </>
  );
};
